import React from "react";
import './Errorpage.css';

function Errorpage(){
    return(
        <>
            <h1>error page</h1>
        </>
    );
}

export default Errorpage;